module.exports = __webpack_public_path__ + "media/images/social-media-influencer-opportunity-4cf29289.png";